import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/fun-ui/Button"
import { HTMLAttributes } from "react";

type Alert = {
  title: string;
  description: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: "link" | "default" | "destructive" | "outline" | "secondary" | "ghost" | null;
  confirm?: () => void;
  asyncConfirm?: () => Promise<void>;
  autoTrigger?: boolean;
} & HTMLAttributes<HTMLDivElement>
export function Alert({
  title,
  description,
  confirmLabel = '确定',
  cancelLabel = '取消',
  confirmVariant = 'default',
  confirm = () => { },
  asyncConfirm = async () => { },
  children,
  autoTrigger = true,
}: Alert) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  return (
    <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
      {
        autoTrigger ? (
          <AlertDialogTrigger asChild>
            {children}
          </AlertDialogTrigger>
        ) : (
          children
        )
      }
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="mt-4">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="outline-none focus-visible:ring-0 cursor-pointer shadow-none h-10">{cancelLabel}</AlertDialogCancel>
          <Button
            variant={confirmVariant}
            onClick={async () => {
              confirm();
              await asyncConfirm();
              setShowDeleteDialog(false);
            }}
            className="outline-none focus-visible:ring-0 cursor-pointer"
          >
            {confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export const AlertTrigger = AlertDialogTrigger;